import { Injectable } from '@jack-henry/frontend-utils/di';
import type { DynamicComponentResult } from '@jack-henry/frontend-utils/lit/dynamic-component-registry';
import { noOp } from '@treasury/utils';
import { html } from 'lit';
import { TmDialogService } from '../../services/dialog';

import './tm-offline.component';

@Injectable()
export class OfflineDialogService {
    constructor(private readonly dialogService: TmDialogService) {}

    private dialogPromise?: Promise<DynamicComponentResult>;

    public open() {
        if (this.dialogPromise) {
            return this.dialogPromise.then(noOp);
        }

        this.dialogPromise = this.dialogService.open(html`<tm-offline></tm-offline>`, 'Offline', {
            preventClose: true,
            showButtons: false,
        });
        this.dialogPromise.then(() => (this.dialogPromise = undefined));

        return this.dialogPromise.then(noOp);
    }

    public close() {
        if (!this.dialogPromise) {
            return Promise.resolve();
        }

        return this.dialogService.close();
    }
}
